import React, { useEffect, useState } from "react";

const FancyBox = ({ children, options = {}, delegate = "[data-fancybox]" }) => {
  const [scriptsLoaded, setScriptsLoaded] = useState(false);

  useEffect(() => {
    const loadFancybox = async () => {
      // Add CSS
      if (!document.querySelector('link[href*="fancybox.css"]')) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href =
          "https://cdn.jsdelivr.net/npm/@fancyapps/ui@5/dist/fancybox/fancybox.css";
        document.head.appendChild(link);
      }

      // Check if script is already loaded
      if (!document.querySelector('script[src*="fancybox.umd.js"]')) {
        return new Promise((resolve) => {
          const script = document.createElement("script");
          script.src =
            "https://cdn.jsdelivr.net/npm/@fancyapps/ui@5/dist/fancybox/fancybox.umd.js";
          script.async = true;
          script.onload = () => resolve(true);
          document.body.appendChild(script);
        });
      }

      return Promise.resolve(true);
    };

    loadFancybox().then(() => {
      setScriptsLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (scriptsLoaded && window.Fancybox) {
      // Initialize Fancybox
      window.Fancybox.bind(delegate, options);

      // Cleanup function
      return () => {
        window.Fancybox.destroy();
      };
    }
  }, [scriptsLoaded, delegate, options]);

  return <>{children}</>;
};

export default FancyBox;
